import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.5 12.6875L12 8L17.5 12.6875M6.5 12.6875L3.5 15.5L7.5 20.5H16.5L20.5 15.5L17.5 12.6875M6.5 12.6875V9.5L4.5 7.5V5.5H8.5M17.5 12.6875V9.5L19.5 7.5V5.5H15.5M8.5 5.5V3.5H15.5V5.5M8.5 5.5H15.5",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }